import React, { useState } from 'react';
import { Elements, useStripe,CardElement, useElements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe('pk_test_51OtB4lKGib0qk5h5vL1qfNXbcp6F0uIOoHcJuxdS1nGT29QxTtykwSCs0bUM3shAbkfM2GmakqymS2uRWSMTOrbh00xQr8dq3Q');

const PaymentForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    phoneNumber: '',
    address: '',
    businessName: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const stripe = useStripe();
  const elements = useElements();

  const makePayment = async () => {
    const stripe = await loadStripe('pk_test_51OtB4lKGib0qk5h5vL1qfNXbcp6F0uIOoHcJuxdS1nGT29QxTtykwSCs0bUM3shAbkfM2GmakqymS2uRWSMTOrbh00xQr8dq3Q')

    const body = {
      products: PaymentForm
    }

    const header = {
      "Content-Type": "application/json"
    }

    try {
      const response = await fetch(`http://localhost:5000/create-checkout-session`, {
        method: 'POST',
        headers: header,
        body: JSON.stringify(body)
      });

      const session = await response.json();
      const result = await stripe.redirectToCheckout({
        sessionId: session.id
      });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <Elements stripe={stripePromise}>
    <div>
      <div className="container-fluid p-0 mb-5">
        <div className="row">
          <div className="col-md-12 position-relative bg-dark text-white py-5" style={{ backgroundImage: `url('https://images.pexels.com/photos/392018/pexels-photo-392018.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1')`, backgroundSize: 'cover', backgroundPosition: 'center', zIndex: 1 }}>
            <div className="position-absolute top-0 start-0 w-100 h-100 opacity-50" style={{ zIndex: -1, backgroundColor: "#ffa500" }}></div>

            <div className="text-left py-5 px-5" style={{ height: 350 }}>
              <h1 className='text-white py-5 pb-3' style={{ zIndex: 100 }}>Payment Form</h1>
            </div>
          </div>
        </div>
      </div>

      <div className='container mt-5 pb-5'>
        <div className='row'>
          <div className='col'>
            <img src="https://images.pexels.com/photos/20450962/pexels-photo-20450962/free-photo-of-two-women-in-an-office-interior-with-shelves.jpeg?auto=compress&cs=tinysrgb&w=600" alt="About" className="img-fluid" />
          </div>
          <div className='col'>
            <Elements stripe={stripePromise}>
              <form>
                <div className="form-group">
                  <label>Name</label>
                  <input type="text" name="name" className="form-control" value={formData.name} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>Phone Number</label>
                  <input type="tel" name="phoneNumber" className="form-control" value={formData.phoneNumber} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>Address</label>
                  <input type="text" name="address" className="form-control" value={formData.address} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>Business Name</label>
                  <input type="text" name="businessName" className="form-control" value={formData.businessName} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>Card details</label>
                  <CardElement className="form-control" />
                </div>
                <button style={{  backgroundColor: "#FFA500" } } onClick={makePayment} type="submit" className="btn btn-primary">Pay Now</button>
              </form>
            </Elements>
          </div>
        </div>
      </div>
    </div>
    </Elements>
  );
};

export default PaymentForm;
